import { fetchStream } from "../../Utils/Index";

export const getNotesNextSteps = async function* (
	noteType: string,
	noteContent: string,
): AsyncGenerator<string> {
	yield* fetchStream("/notes_next_steps", {
		type: noteType,
		content: noteContent,
	});
};
